/**
 * FAQ + CTA landing strip — matches creative mock (warm band, pale blue cards, seal scale).
 */
export const FAQ_CTA_BAND_BG = '#faf9f6';
/** Each FAQ row — very pale blue-tinted panel (standalone / non-band) */
export const FAQ_CARD_BG = '#f0f7ff';
/** In FAQ+CTA band: translucent so the WV seal shows through behind the cards */
export const FAQ_CARD_BG_IN_BAND = 'rgba(240, 247, 255, 0.78)';
export const FAQ_CARD_BORDER = '#bfd6ed';
/** Seal watermark — subtle background treatment behind FAQ + CTA */
export const FAQ_SEAL_WATERMARK_OPACITY = 0.14;
